module.exports = __webpack_public_path__ + "static/img/Technologischer-Fortschritt-370x290.7d4f4799.jpg";